import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { Haptics } from '@capacitor/haptics';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideAppAuth } from '@huddle-sports-platform/app-core';
import { HudHaptics } from '@huddle-sports-platform/ui';

import { routes } from './app.routes';
import { clubBaseHref, clubContinueUrl } from './core/club-slug';
import { auth, db, functions } from './core/firebase';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideIonicAngular(),
    // A club's web app is its own ADDRESS (dublinraiders.huddlesports.ie),
    // so the URL is what says whose app this is - not storage, not the
    // previous navigation. A subdomain needs no base href at all; the
    // fallback path form (`/dublinraiders/...`, for a club whose subdomain
    // is not wired up yet) MOUNTS the app under the slug, and the base href
    // is what makes that invisible: the router strips it when it reads a
    // URL and writes it back when it navigates, which is why every route
    // and every routerLink in this app is still flat. See core/club-slug.
    { provide: APP_BASE_HREF, useFactory: clubBaseHref },
    // Firebase's account emails carry this back: a project has ONE action
    // URL, so a reset asked for on dublinraiders.huddlesports.ie would
    // otherwise land on the shared handler with no idea whose app it came
    // from. The request knows; this is how it says so.
    provideAppAuth({ continueUrl: clubContinueUrl() }),
    provideRouter(routes, withComponentInputBinding()),
    // The kit's haptics bridge (a web no-op): tab taps buzz on device.
    provideAppInitializer(() => inject(HudHaptics).use(Haptics)),
    // Wake the ONE Firebase bootstrap (src/app/core/firebase.ts) at startup:
    // this initialises the app and, in the local loop, connects each service
    // to its emulator on first use before any screen asks for data.
    provideEnvironmentInitializer(() => {
      db();
      auth();
      functions();
    }),
  ],
};
